import { useEffect } from "react";
import { FlaskConical } from "lucide-react";

const ENABLED = process.env.REACT_APP_OWNER_TESTING === "true";

export const OwnerTestingBanner = () => {
  useEffect(() => {
    if (!ENABLED) return;
    document.body.classList.add("owner-testing");
    return () => document.body.classList.remove("owner-testing");
  }, []);

  if (!ENABLED) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] flex h-9 items-center justify-center bg-amber-400 px-3 text-center text-[11px] font-bold tracking-wide text-amber-950 sm:text-xs"
      role="status"
      data-testid="owner-testing-banner"
    >
      <FlaskConical className="mr-1.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      OWNER TESTING SITE — orders placed here are tests only and will not be fulfilled. No real payments are taken.
    </div>
  );
};
